export const SETTINGS_BODY_DIV = "w-100 d-flex flex-column align-items-center flex-grow-1";
